var render = function render(){var _vm=this,_c=_vm._self._c;return _c('GenericButton',{attrs:{"color":_vm.color,"loading":_vm.loading,"mdi-icon":_vm.mdiIcon,"outlined":_vm.outlined,"text":_vm.text,"small-icon":_vm.smallIcon,"small-button":_vm.smallButton},on:{"click:prevent":(event) => _vm.$emit('click:prevent', event)}})
}
var staticRenderFns = []

export { render, staticRenderFns }